export default __webpack_public_path__ + "static/media/chinaKlein.4e156c1a.jpg";